import React from 'react';
import MaterialIcon from 'material-icons-react';

const Play = (props) => {

    return <MaterialIcon icon={"play_arrow"} size={props.iconSize} color={"#fff"} onClick={props.clickHandler} />
}

export default Play;